import { store } from '@/store';
import { useConditions } from '@shared/composables/useConditions';

export function useContactFilters() {
  const base = useConditions(store.getters.contactAttributes);

  return {
    ...base,
  };
}
